function renderCartDrawer() {
  fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newCartContent = doc.querySelector('cart-drawer');
      const currentCart = document.querySelector('cart-drawer');

      if (newCartContent && currentCart) {
        currentCart.innerHTML = newCartContent.innerHTML;
      }
      
      document.querySelector('cart-drawer').classList.remove('is-empty');
      
      updateCartCount()
    })
    .catch(err => console.error('Cart drawer render error:', err));
}

function updateCartCount() {
  fetch('/?section_id=header')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartIcon = doc.querySelector('#cart-icon-bubble');
      const currentCartIcon = document.querySelector('#cart-icon-bubble');
      if (newCartIcon && currentCartIcon) {
        currentCartIcon.innerHTML = newCartIcon.innerHTML;
      }
    })
    .catch(err => console.error('Cart count update error:', err));
}

// Optional: Trigger change on page load to set initial state
function initAjaxAddToCart() {
  const forms = document.querySelectorAll('.js-ajax-add-to-cart-form');

  forms.forEach((form) => {
    if (form.dataset.initialized) return; // prevent duplicate binding
    form.dataset.initialized = "true";

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const button = form.querySelector('.product-card__add-to-cart-btn');
      button?.classList.add('loading');

      const formData = new FormData(form);

      const addRes = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: formData,
      });

      await addRes.json();

      button?.classList.remove('loading');

      renderCartDrawer();
      updateCartCount();

      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.add('active');
        document.body.classList.add('overflow-hidden');
      }
    });
  });
}

function initQuantity() {
  document.addEventListener('click', function (e) {

    if (e.target.matches('.plus')) {
      const form = e.target.closest('.product-card__form');
      const input = form.querySelector('.quantity-input');
      const display = form.querySelector('.quantity-display');

      let value = parseInt(input.value);
      if(value < 10) value++;

      input.value = value;
      display.textContent = value;
    }

    if (e.target.matches('.minus')) {
      const form = e.target.closest('.product-card__form');
      const input = form.querySelector('.quantity-input');
      const display = form.querySelector('.quantity-display');

      let value = parseInt(input.value);
      if (value > 1) value--;

      input.value = value;
      display.textContent = value;
    }

  });
}

function initVariantChange() {
  document.querySelectorAll('.product-card__form').forEach(form => {

    if (form.dataset.variantInit) return;
    form.dataset.variantInit = "true";

    const select = form.querySelector('.variant-select');
    if (!select) return;

    const productDataEl = form.closest('.group').querySelector('.product-data');
    const product = JSON.parse(productDataEl.textContent);

    select.addEventListener('change', function () {
      const variantId = this.value;
      const variant = product.variants.find(v => v.id == variantId);
      if (!variant) return;

      const priceWrapper = form.querySelector('.js-price-wrapper');
      const discountBadge = form.closest('.group').querySelector('.discount-badge');

      const price = variant.price;
      const comparePrice = variant.compare_at_price;

      const formattedPrice = `₹ ${(price / 100).toFixed(2)}`;
      const formattedCompare = comparePrice ? `₹ ${(comparePrice / 100).toFixed(2)}` : '';

      let html = '';

      if (comparePrice && comparePrice > price) {
        html = `
          <span class="price-current text-[24px]/[26px] font-bold text-[#222222]">${formattedPrice}</span>
          <span class="price-original"><s>${formattedCompare}</s></span>
        `;

        if (discountBadge) {
          discountBadge.textContent = `On Sale`;
          discountBadge.style.display = 'inline-block';
        }

      } else {
        html = `<span class="price-current text-[24px]/[26px] font-bold text-[#222222]">${formattedPrice}</span>`;
        if (discountBadge) discountBadge.style.display = 'none';
      }

      priceWrapper.innerHTML = html;

      const button = form.querySelector('.product-card__add-to-cart-btn');

      if (button) {
        if (!variant.available) {
          button.disabled = true;
          button.textContent = 'Sold Out';
          button.classList.add('opacity-50', 'cursor-not-allowed', 'pointer-events-none');
        } else {
          button.disabled = false;
          button.textContent = 'Buy Now';
          button.classList.remove('opacity-50', 'cursor-not-allowed', 'pointer-events-none');
        }
      }

      const input = form.querySelector('input[name="id"]');
      if (input) input.value = variant.id;
    });
  });
}

function initAll() {
  initAjaxAddToCart();
  initVariantChange();
}

document.addEventListener("DOMContentLoaded", () => {
  initAll();
  initQuantity(); // delegation → only once
});